import { useState } from 'react';
import { Button, CircularProgress, Tooltip } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { cloudSync } from '../utils/cloudStorage';
import { useAuthStore } from '../store/authStore';

export default function ButtonCloudSync() {
  const [syncing, setSyncing] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) return null;

  const handleSync = async () => {
    setSyncing(true);
    setDone(false);
    
    setError(null);
    try {
      await cloudSync.pushAll();
      setDone(true);
      setTimeout(() => setDone(false), 3000);
    } catch (err) {
      setError(err.response?.data?.message || 'No se pudo guardar. Tus cambios locales se conservan.');
    } finally { setSyncing(false); }
  };

  return (
    <Tooltip title={error || 'Respaldar todos los datos en la nube'}>
      <Button
        variant="contained"
        color={error ? 'error' : done ? "success" : "primary"}
        onClick={handleSync}
        disabled={syncing}
        startIcon={syncing ? <CircularProgress size={20} color="inherit" /> : (done ? <CheckCircleIcon /> : <CloudUploadIcon />)}
        sx={{ borderRadius: '20px', px: 3 }}
      >
        {syncing ? 'Sincronizando...' : error ? 'Reintentar respaldo' : (done ? '¡Guardado!' : 'Respaldar Todo')}
      </Button>
    </Tooltip>
  );
}
